import { suggestAppAtom } from '@/state/global'
import { ANIMATION_VARIANTS } from '@/utils/constants'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { motion } from 'framer-motion'
import { useAtom } from 'jotai'

function SuggestApp() {
  const [suggestApp, setSuggestApp] = useAtom(suggestAppAtom)
  return (
    <>
      <div className="bg-white fixed flex items-center inset-0 z-50 bg-opacity-80 mx-auto max-w-[820px]">
        <motion.div
          className="w-full h-[70%] absolute layout flex justify-center z-50"
          animate="animate"
          variants={ANIMATION_VARIANTS}
          initial="initial"
          exit="animate"
        >
          <div className="bg-black text-white w-11/12 rounded-2xl pt-2 flex justify-center items-center relative">
            <div className="absolute top-2 right-2" onClick={() => setSuggestApp(false)}>
              <XMarkIcon className="w-7" />
            </div>
            <div className="">
              <h1 className="mt-5 text-gray-200 text-3xl text-center uppercase ">Get the</h1>
              <h1 className="text-gray-200 text-3xl text-center uppercase ">union app</h1>

              <h2 className="text-gray-200 text-lg text-center my-2 font-bold">Order, Pay, Enjoy!</h2>
              <div className="h-16 w-16 flex items-center justify-center bg-primary-blue rounded-lg mt-3 mx-auto">
                <svg width={'50'} height={'50'} viewBox="0 0 145 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M121.408 0C109.718 0 103.134 9.99898 99.194 13.9392C90.239 22.8943 88.1307 2.0699 80.5854 2.0699H72.3979H42.7182V24.1889C42.7182 29.7667 40.3797 32.9137 35.7026 32.9137C31.7444 32.9137 29.6771 30.4831 29.6771 26.3484V2.06478H0V30.3935C0 43.2556 7.82161 50 23.0273 50C34.7175 50 41.3008 40.001 45.241 36.0608C54.1961 27.1057 56.3044 47.9327 63.8497 47.9327H101.717V25.8111C101.717 20.2333 104.055 17.0863 108.732 17.0863C112.691 17.0863 114.758 19.5169 114.758 23.6516V47.9352H144.438V19.6065C144.43 6.74445 136.608 0 121.408 0Z"
                    fill={'#fff'}
                  />
                </svg>
              </div>
              <div className="w-48 h-18 mt-8 mb-4 m-auto">
                <a href="https://apps.apple.com/us/app/tabbedout/id1356461892">
                  <img
                    decoding="async"
                    width="1024"
                    height="342"
                    alt=""
                    data-srcset="https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-1024x342.png 1024w, https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-300x100.png 300w, https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-768x257.png 768w, https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-1536x514.png 1536w, https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-2048x685.png 2048w"
                    data-src="https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-1024x342.png"
                    data-sizes="(max-width: 1024px) 100vw, 1024px"
                    className="w-full h-full"
                    src="https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-1024x342.png"
                    sizes="(max-width: 1024px) 100vw, 1024px"
                    srcSet="https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-1024x342.png 1024w, https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-300x100.png 300w, https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-768x257.png 768w, https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-1536x514.png 1536w, https://getunion.com/wp-content/uploads/2022/04/app-store@33.33x-2048x685.png 2048w"
                  />
                </a>
              </div>
              <div className="w-[13.75rem] h-22">
                <a href="https://play.google.com/store/apps/details?id=com.atxinnovation.tabbedout.production&hl=en_US&gl=US">
                  <img
                    decoding="async"
                    width="1024"
                    height="342"
                    data-srcset="https://getunion.com/wp-content/uploads/2022/04/en_badge_web_generic.png 1024w, https://getunion.com/wp-content/uploads/2022/04/en_badge_web_generic-300x116.png 300w"
                    data-src="https://getunion.com/wp-content/uploads/2022/04/en_badge_web_generic.png"
                    data-sizes="(max-width: 1024px) 100vw, 1024px"
                    className="w-full h-full"
                    src="https://getunion.com/wp-content/uploads/2022/04/en_badge_web_generic.png"
                    sizes="(max-width: 1024px) 100vw, 1024px"
                    srcSet="https://getunion.com/wp-content/uploads/2022/04/en_badge_web_generic.png 1024w, https://getunion.com/wp-content/uploads/2022/04/en_badge_web_generic-300x116.png 300w"
                  />{' '}
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </>
  )
}

export default SuggestApp
